const moduleMentalHealth = {
  namespaced: true,
  state: {
    diagnostic: null,
    cie10_first: "",
    first_diagnostic: "",
  },
  getters: {
    getDiagnostic(state) {
      return state.diagnostic;
    },
    getCie10First(state) {
      return state.first_diagnostic;
    },
    getCie10Code(state) {
      return state.cie10_first;
    },
  },
  mutations: {
    loadDiagnostic(state, diagnostic) {
      state.diagnostic = diagnostic;
    },
    loadCie10First(state, cie10_first) {
      state.cie10_first = cie10_first;
    },
    loadFirstDiagnostic(state, first_diagnostic) {
      state.first_diagnostic = first_diagnostic;
    },
  },
};

export default moduleMentalHealth;
